<template>
    <div class="content">

        <div class="product-info product-info--business">
            <div class="product-info__conditions">
                <h1 class="product-info__title">Бизнес кредит</h1>
                <p class="product-info__description">для предпринимателей  на развитие бизнеса</p>
                <ul class="product-info__conditions-list">
                    <li class="product-info__condition-item"><span class="icon icon--m icon--lock-y"></span>Без залога</li>
                    <li class="product-info__condition-item"><span class="icon icon--m icon--tenge-y"></span>Микрокредит до 1 000 000 тенге
                    </li>
                    <li class="product-info__condition-item"><span class="icon icon--m icon--calendar-36"></span>Срок 12 месяцев
                    </li>
                </ul>
<!--                <p class="product-info__date-of-start"> <span class="icon icon&#45;&#45;s icon&#45;&#45;info-w"></span> <span class="text&#45;&#45;bold">Начало выдач</span> - до конца 2018 года </p>-->
                <button class="button button--yellow product-info__button" v-if="isDesktop" v-scroll-to="'.lead-form'">Сообщить конкретную дату</button>
                <button class="button button--yellow product-info__button" v-else v-scroll-to="{el:'.lead-form', offset: -50}">Сообщить конкретную дату</button>
            </div>
        </div>

           <transition name="fade" v-if="!showThanks">
                <div class="lead-form">
                    <h2 class="lead-form__title">Микрокредиты на любые цели <br> скоро в Казахстане</h2>
                    <!-- <p class="lead-form__description">Оставьте свои контактные данные – <br/> и мы сообщим, когда начнём выдавать Бизнес Кредит</p>

                    <form class="lead-form__vertical-form">
                        <c-input-default
                          :label="'Имя'"
                          v-model="name"
                          :fieldName="'name'"
                        ></c-input-default>
                        <c-input-default
                          :label="'Мобильный телефон'"
                          v-model="phone"
                          v-validate="'required'"
                          :fieldName="'phone'"
                          :mask="'+7(###) ### ## ##'"
                        ></c-input-default>

                        <div class="form-row">
                            <button class="button button--violet" v-bind:disabled="!Complete" @click.prevent="sendLead">Подписаться на уведомление</button>
                        </div>

                    </form> -->
               </div>
            </transition>

            <transition name="fade" v-else>
                <div class="thanks-block">
                    <div class="thanks-block__head"></div>
                    <p class="thanks-block__title">Спасибо!</p>
                    <p class="thanks-block__text">Скоро сообщим Вам о запуске.</p>
                </div>
            </transition>

    </div>
</template>
<script>
  import widthMixin from "@/modules/mixins/widthMixin";

  export default {
    name: "Business",
    mixins: [widthMixin],
    metaInfo: {
        title: 'Бизнес кредит – микрокредит для предпринимателей на развитие бизнеса',
        meta: [
            {name: 'description', content: 'Микрокредит без залога на развитие бизнеса. Кредитная линия в 3 000 000 тенге. Срок 12 месяцев'}
        ],
    },
    data(){
      return {
        phone: '',
        name: '',
        showThanks: false
      }
    },
    methods: {
      sendLead: function () {
        let formData = new FormData();

        formData.append('name', this.name);
        formData.append('phone', this.phone);
        formData.append('product', 'micro');

        let _this = this;
        this.$http.post("http://micra.kz/getLeads.php", formData, {
          withCredentials: false,
          headers: {
            "Content-Type": 'multipart/form-data'
          }
        } ).then(
          (response) => {
            _this.showThanks = true;
            setTimeout(function () {
              _this.showThanks = false;
              _this.name = '';
              _this.phone = '';
            }, 5000)
          },
          (response) => {
            _this.showThanks = true;
            setTimeout(function () {
              _this.showThanks = false;
              _this.name = '';
              _this.phone = '';
            }, 5000)
          }
        );
      }
    },
    computed: {
      Complete(){
        return this.name.length > 3 && this.phone.length === 17;
      }
    }
  };
</script>
<style lang="scss">
    @import "~@/assets/scss/variable";

    @import "~@/assets/scss/site/desktop/product/product-info";
    @import "~@/assets/scss/site/desktop/product/lead-form";

    @import "~@/assets/scss/site/mobile/product/product-info";
    @import "~@/assets/scss/site/mobile/product/lead-form";
</style>
